import { useState, useEffect } from "react";
import { makeStyles } from "@mui/styles";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import FlatButton from "./FlatButton";
import TabPanel from "./TabPanel";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import DatePicker from "./DatePicker";
import CommissionByShopTable from "./CommissionByShopTable";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import { GetOrdersByShop } from "../Business/Infrastructure/Business.presenter";
import accountstatus from "../components/accountstatus";
import ReactExport from "react-export-excel";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
const calculate = new accountstatus();

const commissionContent = {
  background: "white",
  width: "100%",
  height: "auto",
  maxWidth: { xs: "none", lg: "1164px" },
  minWidth: { xs: "none", lg: "1164px" },
  borderRadius: "10px",
  marginTop: { md: "20px", lg: "20px" },
  minHeight: "913px",
  padding: { xs: "60px 5px", sm: "40px 20px", md: "36px 40px 59px" },
};

const typeTabs = {
  fontWeight: 700,
  fontFamily: "Montserrat",
  color: "#000",
  textTransform: "none",
};

const btnExport = {
  height: "32px",
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  headerContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-end",
  },
}));

export default function BusinessCommissionsTable({ businessName, businessId }) {
  const classes = useStyles();
  const [value, setValue] = useState(0);
  const [commissions, setCommissions] = useState([]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    if (businessId) {
      fetchOrdersData(businessId);
    }
  }, [businessId]);

  //Obtener órdenes por negocio
  async function fetchOrdersData(id) {
    try {
      const info = await GetOrdersByShop(id);

      var array = info[0].orders.items;
      var category = info[0].category_shop.items[0].category_id.category_name;
      var documents = info[0].url_documents;
      var zona = info[0].zone;
      var shopname = info[0].shop_name;
      var idshop = info[0].id;
      var res = calculate.calculateAccountStatus(
        array,
        idshop,
        category,
        documents,
        zona,
        shopname
      );
      setCommissions(res);
      console.log("res", res);
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <Box sx={commissionContent}>
      <Box className={classes.headerContainer}>
       {/*  <DatePicker title={"Período (30 días)"} widthDate={"200px"} /> */}
        <ExcelFile
          element={
            <FlatButton
              title={"Exportar"}
              typeButton="button"
              icon={<FileUploadOutlinedIcon />}
              widthBtn="167px"
              customStyles={btnExport}
            />
          }
          filename={"Comisiones"}
        >
          <ExcelSheet data={commissions} name="InformationComercial">
            <ExcelColumn label="Id de orden" value="id" />
            <ExcelColumn label="Fecha" value="creacion" />
            <ExcelColumn label="Dia" value="Fecha" />
            <ExcelColumn label="Hora" value="Hora" />
            <ExcelColumn label="Forma de pago" value="Formadepago" />
            <ExcelColumn label="Importe de Venta" value="Importventa" />
            <ExcelColumn label="Descuento del cliente" value="Descuentocl" />
            <ExcelColumn
              label="Importe de venta sin descuento"
              value="importsindiscount"
            />
            <ExcelColumn
              label="Comisión de envio cliente"
              value="ComsendCustomer"
            />
            <ExcelColumn
              label="Importe de venta mas envio de cliente"
              value="importpluscomcustomer"
            />
            <ExcelColumn label="Tarifa de Servicio" value="tarifeservice" />
            <ExcelColumn label="Monedero" value="MCC" />
            <ExcelColumn label="Sub total" value="Subtotal" />
            <ExcelColumn label="Comisión de Niku" value="ComisionNk" />
            <ExcelColumn label="Sub total sin IVA" value="Subsiniva" />
            <ExcelColumn label="IVA8" value="IVA8" />
            <ExcelColumn label="ISR1" value="ISR1" />
            <ExcelColumn label="Comisión de envio" value="Comsend" />

            <ExcelColumn label="Propina" value="propine" />
            <ExcelColumn label="Repartidor asignado" value="deliveryman" />
            <ExcelColumn
              label="Total a depositar"
              value="TotalADepositarporOrden"
            />
            <ExcelColumn label="Total a cobrar" value="Domicializacion" />
          </ExcelSheet>
        </ExcelFile>
      </Box>

      <Divider sx={{ marginTop: "20px", marginBottom: "20px" }} />

      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          textColor="secondary"
          indicatorColor="secondary"
          value={value}
          onChange={handleChange}
        >
          <Tab sx={typeTabs} label="Comisión por orden" {...a11yProps(0)} />
          {/*  <Tab sx={typeTabs} label="Comisión directa" {...a11yProps(1)} /> */}
        </Tabs>
      </Box>

      <div>
        <TabPanel value={value} index={0}>
          {commissions.length !== 0 ? (
            <CommissionByShopTable
              businessName={businessName}
              data={commissions}
            />
          ) : (
            <h3 style={{ marginTop: "20px" }}>Sin registros</h3>
          )}
        </TabPanel>
        {/*    <TabPanel value={value} index={1}>
          <h3 style={{ marginTop: "20px" }} >Sin registros</h3>
        </TabPanel> */}
      </div>
    </Box>
  );
}
